import config from '@/config'
import { getEndOfDayIso, getStartOfDayIso } from '@/helpers/DateRangeHelper'

const getToken = () => localStorage.getItem('token')

const getFilenameFromHeader = (contentDisposition) => {
	if (!contentDisposition) return ''
	const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
	if (utfMatch) return decodeURIComponent(utfMatch[1].replace(/"/g, ''))
	const match = contentDisposition.match(/filename="?([^";]+)"?/i)
	return match ? match[1] : ''
}

const buildFallbackFilename = (userId, filters = {}) => {
	let filename = `zamowienia-uzytkownika-${userId}`
	if (filters.dateFrom) filename += `-${filters.dateFrom}`
	if (filters.dateTo) filename += `-${filters.dateTo}`
	return `${filename}.pdf`
}

const buildQuery = (filters = {}) => {
	const query = new URLSearchParams()
	if (filters.dateFrom) query.set('createdDate[after]', getStartOfDayIso(filters.dateFrom))
	if (filters.dateTo) query.set('createdDate[before]', getEndOfDayIso(filters.dateTo))
	if (filters.status) query.set('status', filters.status)
	const queryString = query.toString()
	return queryString ? `?${queryString}` : ''
}

const readBlobError = async (response, blob) => {
	const contentType = response.headers.get('content-type') || ''
	let details = ''

	if (contentType.includes('json')) {
		try {
			const payload = JSON.parse(await blob.text())
			details = payload.detail || payload.message || payload.title || ''
		} catch (e) {
			details = ''
		}
	} else {
		details = await blob.text().catch(() => '')
	}

	const error = new Error(details || `HTTP ${response.status}`)
	error.name = 'PdfDownloadError'
	error.status = response.status
	error.details = details
	throw error
}

const downloadOrdersPdf = async (userId, filters = {}) => {
	const token = getToken()
	const url = `${config.service.apiRootURL}user-orders-pdf/${encodeURIComponent(userId)}${buildQuery(filters)}`
	const response = await fetch(url, {
		method: 'GET',
		headers: {
			...(token ? { Authorization: `Bearer ${token}` } : {}),
			Accept: 'application/pdf'
		}
	})
	const blob = await response.blob()

	if (!response.ok) {
		await readBlobError(response, blob)
	}

	const filename = getFilenameFromHeader(response.headers.get('content-disposition')) ||
		buildFallbackFilename(userId, filters)
	const objectUrl = URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = objectUrl
	link.download = filename
	document.body.appendChild(link)
	link.click()
	link.remove()
	window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0)

	return { filename, size: blob.size }
}

export default {
	downloadOrdersPdf
}